import React from 'react';
import T from 'prop-types';

import { ROW_TYPES } from 'workflow/constants/newInbox';
import DetailRows from '../DetailRows/DetailRows';
import DetailRowsv4 from '../DetailRows/DetailRowsv4';

const rowConfigs = [{
    label: 'Sent From',
    field: 'binderName'
}, {
    label: 'Sent By',
    field: 'sentBy'
}, {
    label: 'Sent Date',
    field: 'sentDate',
    type: ROW_TYPES.DATETIME
}, {
    label: 'Type',
    value: 'Delegation'
}, {
    label: 'Start Date',
    field: 'delegation.startDate',
    type: ROW_TYPES.DATE_NO_TZ,
}, {
    label: 'End Date',
    field: 'delegation.endDate',
    type: ROW_TYPES.DATE_NO_TZ,
}, {
    label: 'Statement of Testament',
    field: 'statement'
}, {
    label: 'Tasks',
    field: 'delegation.tasks',
    type: ROW_TYPES.LIST,
    childField: 'taskName'
}];

const rowConfigsV4 = [{
    label: 'Binder',
    field: 'sentFrom',
    type: ROW_TYPES.LINK
}, {
    label: 'Sent By',
    field: 'sentBy'
}, {
    label: 'Sent Date',
    field: 'sentDate',
    type: ROW_TYPES.DATETIME
}, {
    label: 'Type',
    value: 'Delegation'
}, {
    label: 'Start Date',
    field: 'delegation.startDate',
    type: ROW_TYPES.DATE_NO_TZ,
}, {
    label: 'End Date',
    field: 'delegation.endDate',
    type: ROW_TYPES.DATE_NO_TZ,
}, {
    label: 'Statement of Testament',
    field: 'statement'
}, {
    label: 'Tasks',
    field: 'delegation.tasks',
    type: ROW_TYPES.LIST,
    childField: 'taskName'
}];

export const DOARequest = ({ detail = {}, isNewV4, isMobileView }) => isNewV4 ? <DetailRowsv4 data={detail} configs={rowConfigsV4} isMobileView={isMobileView} /> : <DetailRows data={detail} configs={rowConfigs} />;

DOARequest.propTypes = {
    detail: T.object,
    isNewV4: T.bool,
    isMobileView: T.bool
};

export default DOARequest;
